import { HasId } from '../interfaces';

export class Language implements HasId {
    public id: number;
    public name: string;
    public code: string;
}


// WEBPACK FOOTER //
// ./src/models/Language.tsx